import dynamic from 'next/dynamic';
import Router from 'next/router';
import * as React from 'react';

import { Typography, Box, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Element } from 'react-scroll';
import Image from 'src/components/atoms/image';
import config from 'src/config';

import { Style, HeaderContainer } from './style';

const BoxSearch = dynamic(import('@components/molecules/cpdLandingPage/boxSearch'));

type Props = {
  isSupportLargeScreen?: boolean;
  cpdCitizenId: string;
};

const Heading = ({ isSupportLargeScreen, cpdCitizenId }: Props) => {
  const { t } = useTranslation('common');

  const goToCpd = () => {
    Router.push(config.CPD_DOMAIN);
  };

  return (
    <Style
      backgroundImage={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/Banner-SkillLaneCPD.png`}
      backgroundImageMobile={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/Banner-SkillLaneCPD_Mobile.png`}
      contentHeight="360px"
      contentHeightMobile="390px"
    >
      <HeaderContainer isSupportLargeScreen={isSupportLargeScreen}>
        <Box mb={!cpdCitizenId ? '3rem' : ''}>
          <Image
            className="logo-image"
            alt="SkillLaneCPD ระบบอบรมเก็บชั่วโมงออนไลน์"
            src={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/LogoCPD-White.svg`}
            errorImage={`${config.IMAGE_CDN_HOST}assets/cpd-landing/LogoCPD-White.svg`}
          />
          <Typography className="title" variant="h1">
            {t('cpd_landing.overview.title')}
          </Typography>
          <Typography className="description" variant="h4">
            {t('cpd_landing.overview.description')}
          </Typography>
          <Element name="cpdBoxSearchRecommand" />
          <Button variant="outlined" sx={{ my: 3 }} className="go-to-cpd-button" onClick={goToCpd}>
            {t('cpd_landing.login.text')}
          </Button>
        </Box>
        {/* TODO: uncomment if want to use again */}
        {/* {!cpdCitizenId && <BoxSearch />} */}
      </HeaderContainer>
    </Style>
  );
};

export default Heading;
